import { ArrowRight, BookOpen } from 'lucide-react';
import type { HelpCategory } from '../../store/apis/helpCenter.api';
import { Badge } from '../common';

interface HelpCategoriesProps {
    categories: HelpCategory[];
    iconMap: Record<string, React.ReactNode>;
    onCategoryClick: (categoryId: string) => void;
}

export function HelpCategories({ categories, iconMap, onCategoryClick }: HelpCategoriesProps) {
    const getModuleColor = (id: string) => {
        return 'bg-slate-50 text-slate-500 border border-slate-100';
    };

    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {categories.map((category) => (
                <button
                    key={category.id}
                    onClick={() => onCategoryClick(category.id)}
                    className="group relative p-6 bg-white border border-slate-100 rounded-xl hover:border-primary/40 shadow-soft hover:shadow-lg transition-all text-left"
                >
                    <div className="relative flex items-center justify-between mb-4">
                        <div className="flex items-center gap-3">
                            <div className={`w-12 h-12 rounded-full flex items-center justify-center transition-transform duration-300 group-hover:scale-110 ${getModuleColor(category.id)} flex-shrink-0`}>
                                {iconMap[category.icon]}
                            </div>
                            <h3 className="text-base font-bold text-slate-900 group-hover:text-primary transition-colors line-clamp-2">
                                {category.name}
                            </h3>
                        </div>
                        <div className="p-1.5 rounded-full bg-slate-50 text-slate-400 group-hover:bg-primary/10 group-hover:text-primary transition-colors flex-shrink-0 ml-2">
                            <ArrowRight size={14} className="group-hover:translate-x-0.5 transition-transform" />
                        </div>
                    </div>

                    <div className="relative">
                        <p className="text-slate-500 text-xs leading-relaxed mb-6 line-clamp-2 font-medium mt-2">
                            {category.description}
                        </p>

                        <div className="flex items-center gap-2">
                            <Badge variant="gray" size="middle" outline>
                                <div className="flex items-center gap-1.5">
                                    <BookOpen size={10} className="text-slate-400" />
                                    <span className="text-slate-600">{category.articleCount}-Article(s)</span>
                                </div>
                            </Badge>
                        </div>
                    </div>
                </button>
            ))}
        </div>
    );
}
